module.exports = __webpack_public_path__ + "static/media/msrating_108.b7df6384.ico";